
import hashtagType from "../../actions/hashtag/hashtagType";

const initialState = {
    hashtag:[],
    loading: false,
    error: false,
    errorMessage:'',

}

const gradeReducer=( state = initialState, action) => {


switch(action.type) {
case  hashtagType.START_FETCHING_HASHTAG :
    return{
        ...state,
        hashtag:[],
        loading : true,
        error: false
    }
case  hashtagType.SUCCESS_FETCHIED_HASHTAG :
    return{
        ...state,
        loading : false,
        hashtag: action.payload,
        error: false
    }
case  hashtagType.FAILURE_FETCHED_HASHTAG :
    return{
        ...state,
        loading : false,
        hashtag:[],
        error:true,
        errorMessage:action.errorMessage
    }




    default: return state;
}

}


export default gradeReducer